import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

type ButtonTypeT = "submit" | "button";

interface Props {
	func1?: () => void;
	func2?: () => void;
	words1: string;
	icon1?: React.ReactNode;
	words2?: string;
	icon2?: React.ReactNode;
	iconSwap2?: boolean;
	disabled1?: boolean;
	disabled2?: boolean;
	type1?: ButtonTypeT;
	type2?: ButtonTypeT;
}

const FooterButtons = ({
	func1,
	func2,
	words1,
	words2,
	disabled1,
	disabled2,
	icon1,
	icon2,
	type1,
	type2,
}: Props) => {
	return (
		<>
			<div
				className={cn(
					"flex w-full max-w-md mx-auto flex-row-reverse items-center justify-center pt-2",
					"mb-8 flex gap-x-4",
				)}
			>
				{func2 && words2 ? (
					<>
						<Button
							data-testid="footer-primary-button"
							className="w-2/3"
							size="lg"
							disabled={disabled1}
							onClick={func1}
							type={type1 ?? "submit"}
						>
							{words1}
							{!!icon1 && icon1}
						</Button>
						<Button
							data-testid="footer-secondary-button"
							size="lg"
							className="w-1/3"
							disabled={disabled2}
							onClick={func2}
							variant="secondary"
							type={type2 ?? "button"}
						>
							{words2}
							{!!icon2 && icon2}
						</Button>
					</>
				) : (
					<Button size="lg" disabled={disabled1} onClick={func1}>
						{words1}
						{!!icon1 && icon1}
					</Button>
				)}
			</div>
		</>
	);
};

export default FooterButtons;
